import { render, staticRenderFns } from "./ModalTemplate.vue?vue&type=template&id=e4f0a928&scoped=true"
import script from "./ModalTemplate.vue?vue&type=script&lang=js"
export * from "./ModalTemplate.vue?vue&type=script&lang=js"
import style0 from "./ModalTemplate.vue?vue&type=style&index=0&id=e4f0a928&prod&lang=scss"
import style1 from "./ModalTemplate.vue?vue&type=style&index=1&id=e4f0a928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f0a928",
  null
  
)

export default component.exports